import React from "react";
import { Outlet } from "react-router-dom";

// Types
import { MainProps } from "@/types/index";

// Utils
import { cn } from "@/utils/common/cn";

const Main: React.FC<MainProps> = ({ children, className }) => {
  return (
    <main className={cn("flex w-full flex-1 flex-col", className)}>
      {children}
      <section className="text-foreground flex-1 p-4 pt-0 lg:p-6 lg:pt-0">
        <Outlet />
      </section>
    </main>
  );
};

export default Main;
